/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

function PartnerDeliveryProfilesSearchViewController(this: JS5Object, _: JS5Object, $location: JS5Object,
                                                     $routeParams: JS5Object, uiGridConstants: JS5Object,
                                                     PartnerEditService: JS5Object): void {
    const getData = () => {
        this.loadingIndicator.show = true;
        PartnerEditService.getDeliveryProfilesForPartner($routeParams.id).then((deliveryProfiles: JS5Object) => {
            this.gridOptions.data = deliveryProfiles;
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const buildEditViewUrl= (id: string)=>{
        return `/system/partners/edit/${$routeParams.id}/deliveryProfiles/edit/${id}`;
    };

    const navigateToDeliveryProfilesEditViewFromDoubleClick = (row: JS5Object): void => {
        $location.url(buildEditViewUrl(row.id));
    };

    const navigateToCreateView = () => {
        $location.url(buildEditViewUrl('-1'));
    };

    const navigateToEditViewFromEditButton = () => {
        $location.url(buildEditViewUrl(_.first(this.gridApi.selection.getSelectedRows()).id));
    };

    this.onRowDblClick = (row: JS5Object) => {
        navigateToDeliveryProfilesEditViewFromDoubleClick(row.entity);
    };

    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: () => true,
            onClick: navigateToCreateView
        },
        {
            label: 'Edit',
            enabled: () => _.size(this.gridApi.selection.getSelectedRows()),
            onClick: navigateToEditViewFromEditButton
        }
    ];

    let columnDefinitions = [
        {
            field: 'packageAcceptTemplate.name',
            displayName: 'Package Accept Template',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'categoryType.name',
            displayName: 'Content Type',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object): void => {
            this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };
}

angular.module('prism-ui.deliveryProfiles').component('partnerDeliveryProfilesSearchView', {
    controller: PartnerDeliveryProfilesSearchViewController,
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/searchView/partner-delivery-profiles-searchview-template.html'
});
